import { type ToastProps } from '@curology/ui-components-web/react/Toast/ToastState';
import { atom } from 'jotai';
import { type ReactElement } from 'react';

export type FlashMessageProps = Omit<ToastProps, 'icon'> & {
  icon?: ReactElement;
};

const flashMessagesAtom = atom<FlashMessageProps[]>([]);

export const FlashMessagesState = {
  flashMessagesAtom,
};
